<template>
    <div class="auth-container">
        <el-card class="noBorder">
            <template #header>
                <div class="card-header">
                    <el-button type="primary" :icon="CopyDocument" @click="onStartBackup" v-permission="['database:backup']">
                        备份数据
                    </el-button>
                    <el-button :icon="RefreshRight" @click="getTableData">刷新</el-button>
                </div>
            </template>
            <el-table :data="table_data" border v-loading="tableLoading" style="width: 100%">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="name" label="数据库备份目录"></el-table-column>
                <el-table-column prop="create_time" label="备份时间" sortable width="180">
                    <template #default="{ row }">
                        {{ row.create_time ? row.create_time : '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="backup_size" label="大小" width="100">
                    <template #default="{ row }">
                        {{ row.backup_size ? row.backup_size : '-' }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template #default="{ row }">
                        <el-button
                            type="primary"
                            link
                            size="small"
                            :icon="Download"
                            @click="onDownLoadClick(row)"
                            v-permission="['database:download']"
                        >
                            下载
                        </el-button>
                        <el-button
                            type="primary"
                            link
                            size="small"
                            :icon="Delete"
                            @click="onRemoveClick(row)"
                            v-permission="['database:remove']"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { delBackup, getBackupLists, startBackup } from '@/api/database'
import { ElMessage, ElMessageBox } from 'element-plus'
import { CopyDocument, Delete, Download, RefreshRight } from '@element-plus/icons'

// 数据源
const table_data = ref([{}])
const tableLoading = ref(true)
// 获取数据的方法
const getTableData = async () => {
    tableLoading.value = true
    table_data.value = await getBackupLists({})
    tableLoading.value = false
}
getTableData()

// 下载
const onDownLoadClick = (row) => {
    window.open(row.down_path)
}

// 备份数据库
const onStartBackup = () => {
    ElMessageBox.confirm('是否确认备份数据？', {
        type: 'warning'
    })
        .then(async () => {
            startBackup().then((data) => {
                ElMessage.success('备份数据命令已执行成功，请耐心等待，手动点击“刷新”查看结果。')
            })
        })
        .catch(() => {})
}
// 删除

const onRemoveClick = (row) => {
    ElMessageBox.confirm('确定要删除 ' + row.name + ' 吗？', {
        type: 'warning'
    }).then(async () => {
        await delBackup({ path: row.path })
        ElMessage.success('删除成功！')
        // 重新渲染数据
        getTableData()
    })
}

// 被 keep-alive 缓存的组件激活时调用
onMounted(() => {
    getTableData()
})
</script>

<style lang="scss" scoped>
.ml-3 {
    margin-right: 3px;
}
</style>
